/**
 * @name: rebateManagement.js
 * @description: 返利管理路由
 * @author: 杨波
 * @create: 2020/11/19 16:38:51
 * @update: 2020/11/19 16:38:51
 */

export default [
  {
    path: '/rebate/set/list',
    name: 'rebateRuleSetManagement',
    component: () => import('@/views/rebate/set/List'),
    meta: {
      title: '返利规则设置'
    }
  },
  {
    path: '/rebate/set/detail',
    name: 'rebateRuleSetDetail',
    component: () => import('@/views/rebate/set/Detail'),
    meta: {
      title: '返利规则详情',
      parentRoutePath: 'rebateRuleSetManagement'
    }
  },
  {
    path: '/rebate/search/list',
    name: 'rebateRuleSearchManagement',
    component: () => import('@/views/rebate/search/List'),
    meta: {
      title: '返利规则查询'
    }
  },
];
